// extracted by mini-css-extract-plugin
export default {"breakpoint_tablet_max_width_1199":"1199px"};